// app/middleware/dock-transition.global.ts

import { DOCK_TABS } from "~/constants/dockTabs"

function getDockIndex(path: string): number {
    return DOCK_TABS.findIndex((t) => t.path === path)
}

/**
 * Global middleware that sets the Dock tab transition direction.
 *
 * - Dock tab -> Dock tab: direction depends on tab order
 * - Any other navigation: defaults to "left" (existing behavior)
 */
export default defineNuxtRouteMiddleware((to, from) => {
    const dockTransitionDir = useDockTransitionDir()

    const toIndex = getDockIndex(to.path)
    const fromIndex = getDockIndex(from.path)

    if (toIndex !== -1 && fromIndex !== -1) {
        if (toIndex === fromIndex) {
            dockTransitionDir.value = "left"
        } else {
            dockTransitionDir.value = toIndex > fromIndex ? "left" : "right"
        }
    } else {
        dockTransitionDir.value = "left"
    }
})
